import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslationModel, ProductModel, Variant, CarbonSavingsModel } from "../../models/product";
import { productStore } from "@/store/ProductModule";
import {appStore} from "../../store/AppModule";
import { EventBus } from "@/events";
import CalculatorService from "@/services/CalculatorService";

@Component
export default class CarbonSavingsCalculation extends Vue {
    protected vm: any = {};
    protected isModalVisible: boolean = false;
    protected shoppingListPrevious: boolean = false;
    @Prop()
    protected quantity!: number;
    @Prop()
    protected isAddToCartPopUp!: boolean;
    @Prop()
    protected calculationCarbonSavingsModel!: CarbonSavingsModel;
    @Prop()
    protected isConfigurator!: boolean;
    @Prop()
    protected isGDS!: boolean;
    @Prop()
    protected isCalculator!: boolean;
    @Prop()
    protected isProductListModule!: boolean;
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected selectECOProduct() {
        EventBus.$emit("selectedECOvariant", this.carbonSavingsModel, this.isGDS, this.quantity);
    }

    protected saveSessionAndRedirect(url: string) {
        CalculatorService.storeSessionQuantity("carbonsavingsproductquantity", this.carbonSavingsModel.isCurrentVariantECO ? this.quantity : this.quantityWithFactor);
        window.location.href = url;
    }

    get product(): ProductModel {
        return productStore.product;
    }

    get variant(): Variant {
        return productStore.variant;
    }

    get carbonSavingsModel(): CarbonSavingsModel {
        return this.calculationCarbonSavingsModel ? this.calculationCarbonSavingsModel : this.variant.carbonSavingsModel;
    }

    get quantityWithFactor(): number {
        const calculatedQuantity = this.quantity * this.carbonSavingsModel.packagingFactor;
        const quantityToReturn = this.carbonSavingsModel.isCurrentVariantECO ? Math.floor(calculatedQuantity) : Math.ceil(calculatedQuantity);
        return this.quantity > 5 ? quantityToReturn : this.quantity;
    }

    get carbonSavings(): string {
        if (this.carbonSavingsModel.isCurrentVariantECO) {
            return (this.carbonSavingsModel.globalWarmingPotentialMainProduct * this.quantityWithFactor -
                this.carbonSavingsModel.globalWarmingPotentialECOProduct * this.quantity)
                .toLocaleString(appStore.state.culture, {maximumFractionDigits: 1, minimumFractionDigits: 1});
        } else {
            return (this.carbonSavingsModel.globalWarmingPotentialMainProduct * this.quantity -
                this.carbonSavingsModel.globalWarmingPotentialECOProduct * this.quantityWithFactor)
                .toLocaleString(appStore.state.culture, {maximumFractionDigits: 1, minimumFractionDigits: 1});
        }
    }

    get numberOfDigits(): number {
        return  this.carbonSavings.replace(" ", "").length > 2 ? this.carbonSavings.replace(" ", "").length - 2 : 0;
    }

    protected GetVariantDescription(originalDescription: string, kiloUnitText: string, carbonDioxideText: string): string {
        return originalDescription.replace("{sacks}", (this.carbonSavingsModel.isCurrentVariantECO ? this.quantity : this.quantityWithFactor).toString()).replace("{ecoproductname}", this.carbonSavingsModel.ecoVariantName)
        .replace("{carbonsavings}", this.carbonSavings + " " + kiloUnitText + " " + carbonDioxideText);
    }
}
